import { render } from "./SalesForcesView.vue?vue&type=template&id=a1274ee6"
import script from "./SalesForcesView.vue?vue&type=script&lang=js"
export * from "./SalesForcesView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__